<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <section>
      <v-file-input
        @click:clear="clear()"
        v-model="files"
        prepend-icon=""
        show-size
        small-chips
        color="primary"
        prepend-inner-icon="mdi-paperclip"
        dense
        hide-details
        outlined
      >
        <template v-slot:selection="{ index, text }">
          <v-chip v-if="index < 2" color="primary" dark label x-small>
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>

      <xlsx-read :file="files">
        <xlsx-json v-show="headers" @parsed="changeData($event)">
          <template #default="{collection}">
            <div>
              <v-data-table dense :headers="headers" :items="convertCollection(collection)" />
            </div>
          </template>
        </xlsx-json>
      </xlsx-read>
    </section>
    <v-row v-show="headers">
      <v-spacer></v-spacer>
      <v-col lg="6">
        <v-btn color="primary" small block @click="$emit('loaded', items)">Cargar Datos</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { XlsxRead, XlsxTable, XlsxSheets, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";

export default {
  components: {
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  props: { 
    value: null, 
    headers: null, 
    label: { type: String, default: "Seleccione Archivo" },
    validateRow: {
      type: Function, // La función de validación que se recibe como prop
      default: null, // Si no se pasa, la validación será opcional
    },
   },

  data() {
    return {
      items: [],
      file: null,
      files: null,
      selectedSheet: null,
      sheetName: null,
      sheets: [{ name: "SheetOne", data: [{ c: 2 }] }],
      collection: [{ a: 1, b: 2 }],
    };
  },

  methods: {
    clear() {
      this.files = [];
      this.items = [];
      this.$emit("clear");
      this.$emit("input", null);
    },
    changeData(data) {
      this.$emit("changeData", data);
      this.$emit("input", data);
    },
    convertCollection(collection) {
      let list = [];
      if (collection) {
        list = collection
          .filter((item) => (this.validateRow ? this.validateRow(item) : true)) // Filtrado opcional
          .map((item) => {
            let obj = {};
            this.headers.forEach((element) => {
              let rawValue = item[element.column];

              if (element.date) {
                if (!isNaN(rawValue)) {
                  // Si es número (formato Excel), corregimos la conversión restando 25568
                  obj[element.value] = this.$moment(new Date((rawValue - 25568) * 86400 * 1000)).format("YYYY-MM-DD");
                } else {
                  // Si ya es un string, dejarlo tal cual
                  obj[element.value] = this.$moment(rawValue, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                }
              } else if (element.time) {
                if (!isNaN(rawValue)) {
                  // Si es número, convertirlo a HH:mm:ss
                  obj[element.value] = this.$moment.utc(rawValue * 86400 * 1000).format("HH:mm:ss");
                } else {
                  // Si ya es texto, usarlo tal cual
                  obj[element.value] = this.$moment(rawValue, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss");
                }
              } else {
                obj[element.value] = rawValue;
              }
            });
            return obj;
          });
      } else list = [];
      this.items = list;
      return list;
    },
  },
};
</script>
